import axios from 'axios';

export const API_URL =
  import.meta.env.VITE_ENV === 'development'
    ? import.meta.env.VITE_BACKEND_LOCAL
    : import.meta.env.VITE_BACKEND;

export const getAssetUrl = (assetPath) => {
  const cleanPath = String(assetPath || '').replace(/^\/+/, '');
  const base = String(import.meta.env.BASE_URL || '/');
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  return `${normalizedBase}${cleanPath}`;
};

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export default api;
